import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hideGuarantee?: boolean;
  mode?: 'scroll' | 'checkout';
}
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/45913855623356:1';
export function CTAButton({
  children,
  className = '',
  onClick,
  hideGuarantee = false,
  mode = 'scroll'
}: CTAButtonProps) {
  const smoothScrollTo = (targetId: string) => {
    const target = document.getElementById(targetId);
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 1500;
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const animation = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeInOutCubic(progress);
      window.scrollTo(0, startPosition + distance * eased);
      if (elapsed < duration) {
        requestAnimationFrame(animation);
      }
    };
    requestAnimationFrame(animation);
  };
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (mode === 'checkout') {
      window.open(CHECKOUT_URL, '_blank');
    } else {
      smoothScrollTo('compra');
    }
  };
  return <div className="w-full max-w-xl mx-auto" data-id="element-9">
      <motion.button onClick={handleClick} className={`w-full block bg-gradient-to-b from-green-500 to-green-700 text-white font-bold text-xl md:text-2xl py-5 px-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-10">
        {children}
      </motion.button>
      {!hideGuarantee && <p className="text-green-700 font-medium mt-3 flex items-center justify-center gap-2 text-sm" data-id="element-11">
          <ShieldCheckIcon className="w-4 h-4" data-id="element-12" />✅ Garantía de satisfacción de
          7 días
        </p>}
      <p className="text-gray-400 text-xs mt-2 flex items-center justify-center gap-1.5" data-id="element-13">
        <svg className="w-4 h-4 text-blue-400" viewBox="0 0 24 24" fill="currentColor" data-id="element-14">
          <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-.5 5a1 1 0 0 1 1 0l3 5.5a1 1 0 0 1-.87 1.5H8.37a1 1 0 0 1-.87-1.5l3-5.5zM12 17a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" data-id="element-15" />
        </svg>
        🔒 Pago protegido por Mercado Pago
      </p>
    </div>;
}